import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const cityApi = createApi({
  reducerPath: "city",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 300,
  endpoints(builder) {
    return {
      deleteCity: builder.mutation({
        query: (input) => {
          return {
            url: `/api/city/storageRoles/${input.id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
          };
        },
        invalidatesTags: ["City"],
      }),
      addCity: builder.mutation({
        query: (input) => {
          return {
            url: `/api/city/storageRoles`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
            body: {
              ...input,
            },
          };
        },
        invalidatesTags: ["City"],
      }),
      updateCity: builder.mutation({
        query: (input) => {
          return {
            url: `/api/city/storageRoles/${input.id}`,
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
            body: {
              ...input,
            },
          };
        },
        invalidatesTags: ["City"],
      }),
      fetchCity: builder.query({
        query: (token) => {
          return {
            url: "/api/city/storageRoles",
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        },
        providesTags: ["City"],
      }),
    };
  },
});

export const {
  useFetchCityQuery,
  useAddCityMutation,
  useUpdateCityMutation,
  useDeleteCityMutation,
} = cityApi;
export { cityApi };
